import React from "react";
import { DropdownFilterPorpsType } from "./types";
import { BasicIcon, Collapsible } from "@pickit/pickit-components";
import "./DropdownFilter.scss";

const DropdownFilter: React.FC<DropdownFilterPorpsType> = ({
  testId,
  title,
  children,
  isOpen = true,
  collapseTable,
}): JSX.Element => {
  return (
    <div className="dropdown-wrapper">
      <Collapsible startsOpen={isOpen} onClick={collapseTable}>
        <div className="dropdown-title-container">
          <BasicIcon name="adjustments" />
          <p className="title-label" data-testId={`${testId}-label`}>
            {title}
          </p>
        </div>
        <div data-testId={testId} id={testId}>
          {children}
        </div>
      </Collapsible>
    </div>
  );
};

export default DropdownFilter;
